import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const TaskMaster = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [complianceList, setComplianceList] = useState([]);
  const [date, setDate] = useState(new Date().toISOString());
  const [taskId, setTaskId] = useState("");
  const [taskName, setTaskName] = useState("");
  const [taskOperationId, setTaskOperationId] = useState("");
  const [taskOperationName, setTaskOperationName] = useState("");
  const [taskMaxTime, setTaskMaxTime] = useState("");
  const [status, setStatus] = useState("");
  const [lifeSpan, setLifeSpan] = useState("");
  const [lifeSpanOn, setLifeSpanOn] = useState("");
  const [preventiveMaintenance, setPreventiveMaintenance] = useState(false);
  const [precheckJobCardTask, setPreCheckJobCardTask] = useState(false);

  const filteredData = complianceList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "OM_ACTION_NAME",
        "OM_ACTION_OPERATION_TYPE",
        "OM_ACTION_MAX_TIME",
        "OM_ACTION_LIFE_SPAN",
        "OM_ACTION_LIFE_SPAN_ON",
        "OM_ACTION_ID",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1100`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setTaskId(response?.data[0]?.NEWID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching New Task Id :", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1097`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setisloading(false);
        setComplianceList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Compliance details:", error);
      });
  };

  // Saving
  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1099`,
        {
          OM_TASK_ID: Number(taskId),
          OM_TASK_NAME: taskName,
          OM_TASK_OPERATION_ID: Number(taskOperationId),
          OM_TASK_MAX_TIME: Number(taskMaxTime),
          OM_TASK_STATUS: status === "ACTIVE" ? 1 : 0,
          OM_TASK_LIFE_SPAN: Number(lifeSpan),
          OM_TASK_LIFE_SPAN_ON: lifeSpanOn,
          OM_TASK_PREVENTIVE_MAINTENANCE:
            preventiveMaintenance === true ? 1 : 0,
          OM_TASK_PRECHECK_JOB_CARD_TASK: precheckJobCardTask === true ? 1 : 0,
          OM_TASK_PROCESSED_BY: user,
          OM_TASK_PROCESSED_DATE: moment(date).format("YYYY/MM/DD"),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Task Master Saved successfully`);
        console.log(`Task Master Saved successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Task Master`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Task Master`, error);
    }
  }

  const handleRowClick = (value, index) => {
    setTaskId(value.OM_ACTION_ID);
    setTaskName(value.OM_ACTION_NAME);
    setTaskOperationId(value.OM_ACTION_OPERATION_TYPE);
    setTaskMaxTime(value.OM_ACTION_MAX_TIME);
    setStatus(value.OM_ACTION_STATUS === true ? "ACTIVE" : "INACTIVE");
    setLifeSpan(value.OM_ACTION_LIFE_SPAN);
    setLifeSpanOn(value.OM_ACTION_LIFE_SPAN_ON);
    setPreventiveMaintenance(value.OM_ACTION_PREVENTIVE_MAINTENANCE);
    setPreCheckJobCardTask(value.OM_ACTION_JOB_CARD_PRECHECK_TASK);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Task Master
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>

      <div className="flex justify-center mt-6">
        <div className="bg-white border border-gray-300 shadow-md rounded-lg p-6 w-[95%] lg:w-[1150px]">
          {/* Save Button */}
          <div className="flex justify-end gap-3 mb-4">
            <button
              className="flex items-center justify-center bg-[#002d62] hover:bg-[#004080] text-white font-semibold rounded-md px-4 py-2 transition-all duration-200 border border-black"
              onClick={() => {
                window.location.reload();
              }}
            >
              New
            </button>

            <button
              className="flex items-center justify-center bg-[#002d62] hover:bg-[#004080] text-white font-semibold rounded-md px-4 py-2 transition-all duration-200 border border-black"
              onClick={async () => {
                if (!taskName) {
                  alert("Kindly Supply Task Name");
                  return;
                } else if (!taskOperationId) {
                  alert("Kindly Supply Task Operation Id");
                  return;
                } else if (!taskMaxTime) {
                  alert("Kindly Supply Task Max Time");
                  return;
                } else if (!status) {
                  alert("Kindly Supply Status");
                  return;
                } else if (!lifeSpan) {
                  alert("Kindly Supply Life Span");
                  return;
                } else if (!lifeSpanOn) {
                  alert("Kindly Supply Life Span On");
                  return;
                } else {
                  await SaveGateIn();
                  window.location.reload();
                }
              }}
            >
              Save
            </button>
          </div>

          <div className="flex flex-col lg:flex-row items-center gap-4">
            <div className="flex flex-col lg:flex-row lg:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                Task Id:
              </label>
              <input
                className="w-full lg:w-20 h-8 lg:ml-16 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500 text-right"
                type="text"
                value={taskId}
                readOnly
              />
            </div>

            <div className="flex flex-col lg:flex-row lg:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0 lg:ml-12">
                Task Name:
              </label>
              <input
                className="w-full lg:w-64 h-8 lg:ml-4 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500"
                type="text"
                value={taskName}
                onChange={(e) => setTaskName(e.target.value)}
              />
            </div>

            <div className="flex flex-col lg:flex-row lg:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0 lg:ml-20">
                Task Operation:
              </label>
              <Select
                className="lg:w-56 w-72 lg:ml-1"
                value={
                  taskOperationName
                    ? { value: taskOperationName, label: taskOperationName }
                    : { value: "", label: "Select Task Operation" }
                }
                onChange={(e) => {
                  setTaskOperationId(e.value);
                  setTaskOperationName(e.label);
                }}
                options={[
                  { value: "", label: "Select Task Operation" },
                  { value: "1", label: "TEST" },
                ]}
              ></Select>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row items-center gap-4 mt-3">
            <div className="flex flex-col lg:flex-row lg:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                Task Max Time:
              </label>
              <input
                className="w-full lg:w-32 h-8 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500"
                type="number"
                value={taskMaxTime}
                onChange={(e) => setTaskMaxTime(e.target.value)}
              />
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                Task Status :
              </label>
              <Select
                className="lg:w-36 w-72 lg:ml-2"
                value={
                  status
                    ? { value: status, label: status }
                    : { value: "", label: "Select Status" }
                }
                onChange={(e) => {
                  setStatus(e.value);
                }}
                options={[
                  { value: "", label: "Select Status" },
                  { value: "ACTIVE", label: "ACTIVE" },
                  { value: "INACTIVE", label: "INACTIVE" },
                ]}
              ></Select>
            </div>

            <div className="flex flex-col lg:flex-row lg:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                Life Span :
              </label>
              <input
                className="w-full lg:w-24 h-8 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500"
                type="number"
                value={lifeSpan}
                onChange={(e) => setLifeSpan(e.target.value)}
              />
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                Life Span On :
              </label>
              <Select
                className="lg:w-56 w-72 lg:ml-2"
                value={
                  lifeSpanOn
                    ? { value: lifeSpanOn, label: lifeSpanOn }
                    : { value: "", label: "Select Life Span On" }
                }
                onChange={(e) => {
                  setLifeSpanOn(e.value);
                }}
                options={[
                  { value: "", label: "Select Life Span On" },
                  { value: "DAYS", label: "DAYS" },
                  { value: "KM", label: "KM" },
                ]}
              ></Select>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row items-center gap-4 mt-3">
            <div className="flex flex-row items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                Preventive Maintenance :
              </label>
              <input
                className="w-full lg:w-10 h-8 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500"
                type="checkbox"
                checked={preventiveMaintenance}
                onChange={() =>
                  setPreventiveMaintenance(!preventiveMaintenance)
                }
              />
            </div>

            <div className="flex flex-row items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0 lg:ml-2">
                Precheck Job Card Task:
              </label>
              <input
                className="w-full ml-2 lg:ml-0 lg:w-10 h-8 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500"
                type="checkbox"
                checked={precheckJobCardTask}
                onChange={() => setPreCheckJobCardTask(!precheckJobCardTask)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-left border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TASK ID
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TASK NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                OPERATION TYPE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAX TIME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                STATUS
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                LIFE SPAN
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                LIFE SPAN ON
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                PREVENTIVE MAINTENANCE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                JOB CARD RECHECK TASK
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_ID || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_NAME || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_OPERATION_TYPE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_MAX_TIME || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_STATUS === true ? "ACTIVE" : "INACTIVE"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_LIFE_SPAN || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_LIFE_SPAN_ON || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_PREVENTIVE_MAINTENANCE === true
                    ? "YES"
                    : "NO"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_JOB_CARD_PRECHECK_TASK === true
                    ? "YES"
                    : "NO"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TaskMaster;
